import { FAIRY_LINES } from '../constants/fairyLines';

// Índice de la última frase usada por hada+situación — se reinicia al recargar (deseable)
const lastUsed = {};

export function getFairyLine(fairyId, situation, vars = {}) {
  const fairy = FAIRY_LINES[fairyId] || FAIRY_LINES.aurora;
  const lines = fairy[situation];

  if (!lines || lines.length === 0) return null;

  const key  = `${fairyId}_${situation}`;
  const last = lastUsed[key] ?? -1;

  let idx;
  do {
    idx = Math.floor(Math.random() * lines.length);
  } while (idx === last && lines.length > 1);

  lastUsed[key] = idx;

  let line = lines[idx];
  for (const [k, v] of Object.entries(vars)) {
    line = line.replaceAll(`{${k}}`, v);
  }

  return line;
}
